// auth/auth.guard.ts
import { CanActivateFn } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

// Delega para o guard da lib: ele guarda a rota pretendida antes de mandar ao
// IdP e volta para ela após o callback, em vez de cair sempre no postLoginRoute
export const authGuard: CanActivateFn = (route, state) =>
  autoLoginPartialRoutesGuard(route, state);
